export default __webpack_public_path__ + "static/media/najpravo.980e2170.webp";